/**
 * ContactCTA - Home page contact call-to-action banner
 * Redesigned as a clean, high-contrast luxury corporate closer
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import AnimatedSection from '../ui/AnimatedSection';

const ContactCTA = () => (
  <section style={{
    padding: '4.5rem 0',
    background: 'var(--navy)',
    position: 'relative',
    overflow: 'hidden',
    borderTop: '1px solid var(--orange-border)'
  }}>
    {/* Architectural grid overlay */}
    <div style={{
      position: 'absolute', inset: 0, opacity: 0.015,
      backgroundImage: `linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)`,
      backgroundSize: '100px 100px', pointerEvents: 'none'
    }} />

    <div className="container-xxl px-4 px-lg-5" style={{ position: 'relative', zIndex: 1 }}>
      <div className="row align-items-center g-5">
        
        {/* Left Column: Narrative Copy */}
        <div className="col-lg-7">
          <AnimatedSection variant="fadeLeft">
            <span className="section-tag" style={{ background: 'var(--orange-dim)', color: 'var(--orange)', borderColor: 'var(--orange-border)' }}>
              Let's Connect
            </span>
            <h2 style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 800,
              color: '#FFFFFF',
              marginBottom: '1.5rem',
              fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
              letterSpacing: '-0.02em',
              lineHeight: 1.15
            }}>
              Ready to Navigate Your Logistics<br />
              With Absolute <span style={{ color: 'var(--orange)' }}>Confidence?</span>
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.92rem', lineHeight: '1.8', marginBottom: '2.5rem', maxWidth: '520px' }}>
              Contact ISAAC Logistic Solutions today. Our specialized operations desk is available 24/7 to manage your vessel calls, project cargo movements, and supply chain demands.
            </p>

            {/* Direct Lines */}
            <div className="d-flex flex-wrap gap-4 mt-3">
              <a href="tel:+917010755885" style={{
                display: 'flex', alignItems: 'center', gap: '0.6rem',
                color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '0.82rem',
                fontFamily: 'var(--font-heading)', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase'
              }} className="cta-link-hover">
                <FaPhone size={10} color="var(--orange)" />
                +91 70107 55885
              </a>
              <a href="mailto:info@isaacgroup.net" style={{
                display: 'flex', alignItems: 'center', gap: '0.6rem',
                color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: '0.82rem',
                fontFamily: 'var(--font-heading)', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase'
              }} className="cta-link-hover">
                <FaEnvelope size={10} color="var(--orange)" />
                info@isaacgroup.net
              </a>
            </div>
          </AnimatedSection>
        </div>

        {/* Right Column: Clean Action Panel */}
        <div className="col-lg-5">
          <AnimatedSection variant="fadeRight" delay={0.1}>
            <div className="d-flex flex-column gap-3" style={{ maxWidth: '360px', marginLeft: 'auto' }}>
              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }}>
                <Link to="/contact" style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'var(--orange)',
                  color: 'var(--navy)', fontFamily: 'var(--font-heading)', fontWeight: 700,
                  padding: '1.1rem 1.8rem', borderRadius: 2, textDecoration: 'none',
                  fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '1.5px',
                  transition: 'all 0.25s ease'
                }} className="btn-cta-submit">
                  <span>Contact Us Now</span>
                  <FaArrowRight size={10} />
                </Link>
              </motion.div>
              
              <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.98 }}>
                <Link to="/services" style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff', fontFamily: 'var(--font-heading)', fontWeight: 600,
                  padding: '1.1rem 1.8rem', borderRadius: 2, textDecoration: 'none',
                  fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '1.5px',
                  transition: 'all 0.25s ease'
                }} className="btn-cta-explore">
                  <span>View Our Services</span>
                  <FaArrowRight size={10} />
                </Link>
              </motion.div>
            </div>
          </AnimatedSection>
        </div>

      </div>
    </div>

    <style>{`
      .cta-link-hover:hover {
        color: var(--orange) !important;
      }
      .btn-cta-submit:hover {
        background: var(--orange-light) !important;
      }
      .btn-cta-explore:hover {
        background: rgba(255,255,255,0.06) !important;
        border-color: rgba(255,255,255,0.2) !important;
      }
    `}</style>
  </section>
);

export default ContactCTA;
